export default __webpack_public_path__ + "static/media/bang-cap-11_07.1ad2f12f.jpg";